/* eslint-disable no-console */
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

@Injectable({providedIn: 'root'})
export class LoggerService<T> {
  constructor() { }
  
  log(message: T, level: 'verbose' | 'warn' | 'error' = 'verbose'): void {
    if (environment.production) {
      if (level === 'warn') {
        console.warn(message);
      } else if (level === 'error') {
        console.error(message);
      }
    } else {
      console.debug(message);
    }
  }
}